/**
 * The sticky note tool's own controls (SRS C4): which of the six colours a note is.
 *
 * The colours themselves live in the stylesheet, never here, so a note on screen and
 * a note painted on the canvas are always the same yellow.
 */

import { STICKY_PAPERS, stickySwatch } from '../../board/sticky-colors.js';
import { useBoardStore } from '../../board/store.js';

export function StickyControls() {
  const stickyColor = useBoardStore((state) => state.stickyColor);
  const setStickyColor = useBoardStore((state) => state.setStickyColor);

  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-sm font-medium text-text-secondary">Note colour</h3>
      <div className="grid grid-cols-6 gap-2">
        {STICKY_PAPERS.map(({ value, name }) => (
          <button
            key={value}
            type="button"
            aria-pressed={stickyColor === value}
            aria-label={name}
            title={name}
            // Keeps the caret on the note being written on, so the paper can be
            // changed halfway through a sentence.
            onMouseDown={(event) => {
              event.preventDefault();
            }}
            onClick={() => {
              setStickyColor(value);
            }}
            style={{ background: stickySwatch(value) }}
            className={`aspect-square rounded-md border-2 transition-colors duration-fast ${
              stickyColor === value ? 'border-primary' : 'border-border'
            }`}
          />
        ))}
      </div>
      <p className="text-xs text-text-secondary">
        Tap the board to drop a note there and start writing. Tap away when you are done.
      </p>
    </section>
  );
}
